import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6ff69cea&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=6ff69cea&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff69cea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ff69cea')) {
      api.createRecord('6ff69cea', component.options)
    } else {
      api.reload('6ff69cea', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6ff69cea&scoped=true", function () {
      api.rerender('6ff69cea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Notice/index.vue"
export default component.exports